import * as API from '../api';

export const get = (userMission) => {
    if (userMission) {
        // logic must be here
        let areaParam = `usermission=${userMission}`;
        return API.getQuestion(areaParam);
    }
    return API.getQuestion();
};



// WEBPACK FOOTER //
// ./src/controllers/question.js